var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1538 13H2.38462C2.01739 13 1.66521 12.8541 1.40554 12.5945C1.14588 12.3348 1 11.9826 1 11.6154C1 11.2482 1.14588 10.896 1.40554 10.6363C1.66521 10.3766 2.01739 10.2308 2.38462 10.2308H10.2308M10.2308 10.2308C10.4756 10.2308 10.7104 10.1335 10.8835 9.96041C11.0566 9.7873 11.1538 9.55251 11.1538 9.30769V1.92308C11.1538 1.67826 11.0566 1.44347 10.8835 1.27036C10.7104 1.09725 10.4756 1 10.2308 1H2.38462C2.0237 0.999872 1.677 1.14067 1.41837 1.3924C1.15974 1.64414 1.00962 1.98691 1 2.34769V11.5785M10.2308 10.2308V13",
    stroke: "#424444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.04678 5.15691H9.18463L6.91386 8.36276H9.31755M2.85693 6.06522L3.84093 3.1123C3.86551 3.03869 3.9126 2.97467 3.97554 2.92929C4.03849 2.8839 4.1141 2.85944 4.1917 2.85938C4.3514 2.85938 4.49355 2.96091 4.54432 3.1123L5.52832 6.06522M3.21324 4.9963H5.17201",
    stroke: "#424444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/languageIcon.4347a3681aee6b3bd7a989d947d9faeb.svg";
export { ForwardRef as ReactComponent };